// extracted by mini-css-extract-plugin
export default {"block":"BlockCards_block__jZnHX","temp":"BlockCards_temp__zM-Y5"};